import { render, staticRenderFns } from "./TableFile.vue?vue&type=template&id=b37d2cd6&"
import script from "./TableFile.vue?vue&type=script&lang=js&"
export * from "./TableFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports